/* eslint-disable react/jsx-no-bind */
import React, {useEffect, useState} from "react";
import API from "../modules/API";
import EventsAPI from "../modules/EventsAPI";
import {Link} from "react-router-dom";
import LoadingSpinner from "../../bundles/BuyItNow/components/LoadingSpinner";
import ProductDescriptorsAPI from "../../bundles/Product/modules/ProductDescriptorsAPI";
import PropTypes from "prop-types";

const RecommendedItems = ({forProductDescriptorId}) => {
  const [
    products,
    setProducts
  ] = useState([]);

  const [
    isLoading,
    setIsLoading
  ] = useState(true);

  useEffect(() => {
    ProductDescriptorsAPI.fetchProductPageRecommendations(forProductDescriptorId).then((response) => {
      if (response.error) {
        console.log(response.error);
      } else {
        setProducts(response.data.product_descriptors);
      }
      setIsLoading(false);
    });
  }, []);

  const handleClick = (productDescriptorId) => {
    if (API.CUSTOMER_ID) {
      EventsAPI.trackCustomerEvent("clicked_on_recommended_pdp", `product_descriptor_id: ${productDescriptorId}`);
    }
  };

  return (
    <section className="recommended-items-section">
      <h3>
        You May Also Like
      </h3>
      {isLoading &&
        <LoadingSpinner color="black" />}
      {(!isLoading && products.length === 0) &&
        <div>
          There are no recommendations at this time.
        </div>}
      {(!isLoading && products.length !== 0) &&
        <div className="recommended-items">
          {products && products.map(product => (
            <Link
              className="recommended-item relative image-link"
              key={product.id}
              onClick={() => handleClick(product.id)}
              title={product.details.name}
              to={product.details.url}
            >
              <div className="recommended-item-image">
                <img src={product.details.thumbnail_urls[0]} />
              </div>
              <div className="recommended-item-desc">
                <div className="recommended-item-designer">
                  {product.details.designer}
                </div>
                <div className="recommended-item-name">
                  {product.details.name}
                </div>
              </div>
            </Link>
          ))}
        </div>}
    </section>);
};

RecommendedItems.propTypes = {"forProductDescriptorId": PropTypes.number.isRequired};

export default RecommendedItems;
